class CollectionFilter extends HTMLElement {
  constructor() {
    super();
    let htmlliElement = this.querySelectorAll("li");
    htmlliElement.forEach(elem => {
      elem.addEventListener("click", function (e) {
        if (elem.classList.contains("activeFiler")) {
          elem.classList.remove("activeFiler");
          document.querySelector("#product-grid").querySelectorAll("li").
          forEach(e => e.classList.remove("hidden"));
        }
        else{
          htmlliElement.forEach(not => {
            not.classList.remove("activeFiler");
          });
          elem.classList.add("activeFiler");
          document.querySelectorAll("#product-grid").forEach(ul => {
            ul.querySelectorAll("li").forEach(e => {
              if(e.getAttribute("data-material") ===  elem.getAttribute("data-material"))
                e.classList.remove("hidden");
              else
              {
                e.classList.add("hidden");
              }
            });
          });
        }

      });

    } )
  }
}
if (!customElements.get('collection-filter')) {
  customElements.define('collection-filter', CollectionFilter);
}
